import React from 'react';
import { Formik, Form } from 'formik';
import LogInMutation from '@jetshop/core/components/Mutation/LogInMutation';
import validate from './logInValidator';
import t from '@jetshop/intl';
import get from 'lodash.get';
const LogInFormProvider = ({ children }) => {
    return (React.createElement(LogInMutation, null, (login) => (React.createElement(Formik, { validate: validate, initialValues: {
            email: '',
            password: ''
        }, onSubmit: (values, actions) => {
            const { email, password } = values;
            login(email, password).then(() => {
                actions.setSubmitting(false);
            }, error => {
                actions.setSubmitting(false);
                actions.setErrors(error);
                actions.setStatus({
                    globalError: t('Login failed. Please try again')
                });
            });
        }, render: props => (React.createElement(Form, null, children(Object.assign({}, props, { globalError: get(props, 'status.error') })))) }))));
};
export default LogInFormProvider;
//# sourceMappingURL=LogInFormProvider.js.map